var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "magnifying-glass",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 8.875C2 5.07804 5.07804 2 8.875 2C12.672 2 15.75 5.07804 15.75 8.875C15.75 10.7714 14.9822 12.4885 13.7404 13.7323C13.7389 13.7338 13.7375 13.7352 13.736 13.7367C13.7346 13.7381 13.7331 13.7395 13.7317 13.741C12.488 14.9824 10.7711 15.75 8.875 15.75C5.07804 15.75 2 12.672 2 8.875ZM14.4034 15.8183C12.8868 17.0274 10.9653 17.75 8.875 17.75C3.97347 17.75 0 13.7765 0 8.875C0 3.97347 3.97347 0 8.875 0C13.7765 0 17.75 3.97347 17.75 8.875C17.75 10.9657 17.0271 12.8875 15.8177 14.4041L19.7065 18.293C20.0971 18.6835 20.0971 19.3167 19.7065 19.7072C19.316 20.0977 18.6828 20.0977 18.2923 19.7072L14.4034 15.8183Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifying-glass.b41a5ca7990d984204acef25d70b698a.svg";
export { ForwardRef as ReactComponent };